import PropTypes from 'prop-types';

import Dropzone from 'react-dropzone';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import IconButton from '@mui/material/IconButton';
import Tooltip from "@mui/material/Tooltip";
import FormHelperText from '@mui/material/FormHelperText';

const FileDropZone = ({
  uploadInitValues, setUploadInitValues, uploadOptions,
  apiRes, setApiRes, getInfoModalColumns, formErrors,
  onSubmit, organisation,
}) => {
  const validateFile = sfile => {
    if (sfile.length === 1) {
      if (sfile[0].name) {
        if (sfile[0].name.split('.').slice(-1).pop() === 'csv') {
          setUploadInitValues(prev => ({
            ...prev,
            file: sfile[0]
          }));
        } else {
          setApiRes({
            ...apiRes,
            axiosError: true,
            errHeading: 'File Upload',
            errMsg: 'please upload a csv file.',
          });
        }
      } else {
        setApiRes({
          ...apiRes,
          axiosError: true,
          errHeading: 'File Upload',
          errMsg: 'File upload error. Please upload a valid csv file.',
        });
      }
    } else {
      setApiRes({
        ...apiRes,
        axiosError: true,
        errHeading: 'File Upload',
        errMsg: 'File upload error. Please upload a single csv file.',
      });
    }
  };

  return (
    <Grid container spacing={2} style={{ marginTop: 1 }}>
      <Grid item xs={12} md={8}>
        <Box sx={{
          height: 240,
          border: (
            (!uploadInitValues?.file && 'file' in formErrors) ? '2px dashed #d32f2f' : '2px dashed black'
          ),
          textAlign: 'center',
          cursor: 'pointer',
          backgroundColor: 'white',
        }}>
          <Dropzone onDrop={acceptedFiles => validateFile(acceptedFiles)}>
            {({ getRootProps, getInputProps }) => (
              <section style={{ marginTop: '60px' }}>
                <div {...getRootProps()}>
                  <input {...getInputProps()} />
                  <FileUploadIcon sx={{ fontSize: '60px' }} />
                  <p><b>Drag 'n' drop csv file here, or click to select file</b></p>
                  {uploadInitValues?.file && <p><i>{uploadInitValues?.file.name}</i></p>}
                </div>
              </section>
            )}
          </Dropzone>
        </Box>
        {
          (!uploadInitValues?.file && 'file' in formErrors) &&
          <p style={{ color: '#d32f2f', fontSize: '12px' }}>{formErrors.file}</p>
        }
      </Grid>

      <Grid item xs={10} md={3.25} lg={3.5}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
          }}
        >
          <Box>
            <FormControl style={{ width: '100%' }} error={'dataType' in formErrors}>
              <InputLabel id="type">Type</InputLabel>
              <Select
                labelId="type"
                id="type"
                name="type"
                value={uploadInitValues?.dataType}
                label="type"
                onChange={e => setUploadInitValues(prev => ({
                  ...prev,
                  dataType: e.target.value,
                }))}
                sx={{ backgroundColor: 'white' }}
              >
                {uploadOptions?.fileTypeList.map((data, index) => (
                  <MenuItem value={data} key={index}>{data}</MenuItem>
                ))}
              </Select>
              <FormHelperText>{formErrors.dataType}</FormHelperText>
            </FormControl>
          </Box>

          {organisation === 'CPI' &&
            <Box>
              <FormControl style={{ width: '100%' }} error={'ownedBy' in formErrors}>
                <InputLabel id="type">Owned By</InputLabel>
                <Select
                  labelId="organisation"
                  id="organisation"
                  name="organisation"
                  value={uploadInitValues?.ownedBy}
                  label="Owned By"
                  onChange={e => setUploadInitValues(prev => ({
                    ...prev,
                    ownedBy: e.target.value
                  }))}
                  sx={{ backgroundColor: 'white' }}
                >
                  {uploadOptions?.organisationsList.map((data, index) => (
                    <MenuItem value={data} key={index}>{data}</MenuItem>
                  ))}
                </Select>
                <FormHelperText>{formErrors.ownedBy}</FormHelperText>
              </FormControl>
            </Box>
          }

          <Box>
            <FormControl style={{ width: '100%' }} error={'project' in formErrors}>
              <InputLabel id="type">Project</InputLabel>
              <Select
                labelId="organisation"
                id="organisation"
                name="organisation"
                value={uploadInitValues?.project}
                label="Owned By"
                onChange={e => setUploadInitValues(prev => ({
                  ...prev,
                  project: e.target.value
                }))}
                sx={{ backgroundColor: 'white' }}
              >
                {uploadOptions?.projectList.map((data, index) => (
                  <MenuItem value={data} key={index}>{data}</MenuItem>
                ))}
              </Select>
              <FormHelperText>{formErrors.project}</FormHelperText>
            </FormControl>
          </Box>

          <Box>
            <Button
              variant="contained"
              color="success"
              onClick={onSubmit}
              sx={{ width: '100%' }}
            >
              Upload
            </Button>
          </Box>
        </Box>
      </Grid>

      <Grid item xs={2} md={0.75} lg={0.5}>
        <Tooltip title="View columns" arrow>
          <IconButton
            size="small"
            aria-label="show columns"
            color="inherit"
            onClick={getInfoModalColumns}
          >
            <InfoOutlinedIcon />
          </IconButton>
        </Tooltip>
      </Grid>
    </Grid>
  );
};

FileDropZone.propTypes = {
  uploadInitValues: PropTypes.object.isRequired,
  setUploadInitValues: PropTypes.func.isRequired,
  uploadOptions: PropTypes.object.isRequired,
  apiRes: PropTypes.object.isRequired,
  setApiRes: PropTypes.func.isRequired,
  getInfoModalColumns: PropTypes.func.isRequired,
  formErrors: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  organisation: PropTypes.string.isRequired,
};

export default FileDropZone;